// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Card, CardHeader, CardContent, Typography, Grid } from '@material-ui/core';

/**
 * @typedef {Object} CardRoundedProps
 * @property {{ [x: string]: * }} classes
 * @property {string} [title]
 * @property {React.ReactNode} [titleAction]
 * @property {React.ReactNode} [action]
 * @property {React.ReactNode} [children]
 * @property {boolean} [noShadow]
 * @property {boolean} [noBox]
 */

/** @param {CardRoundedProps} props */
const CardRounded = ({ classes, title, titleAction, action, children, noShadow, noBox }) => (
  <>
    {title && (
      <Grid container justifyContent="space-between">
        <Typography variant="h3" paragraph>
          {title}
        </Typography>
        {titleAction}
      </Grid>
    )}
    <Card classes={{ root: cx(classes.card, noShadow && classes.noShadow, noBox && classes.noBox) }}>
      {action && <CardHeader action={action} classes={{ root: classes.header, action: classes.action }} />}
      <CardContent classes={{ root: classes.content }}>{children}</CardContent>
    </Card>
  </>
);

CardRounded.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  /** The title of the CardRounded. */
  title: PropTypes.string,
  /** Additional action in the title */
  titleAction: PropTypes.node,
  /** The action to be forwarded into CardHeader */
  action: PropTypes.node,
  /** Will be rendered inside CardContent */
  children: PropTypes.node,
  /** Removes the shadow of the Card */
  noShadow: PropTypes.bool,
  /** Disables paddings, margins and border */
  noBox: PropTypes.bool,
};

CardRounded.defaultProps = {
  classes: {},
};

export default CardRounded;
